import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function FeatureGrid() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-2">
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">
            分类浏览
          </span>
        </div>
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50">
            探索韩漫宇宙
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Link
            to="/category/rexue"
            className="group relative rounded-3xl overflow-hidden bg-background-200/60 hover:bg-background-200 transition-colors duration-300 cursor-pointer"
          >
            <div className="p-8 md:p-10">
              <div className="w-14 h-14 rounded-2xl bg-background-300/50 flex items-center justify-center mb-6 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className="ri-fire-line text-2xl text-foreground-300 group-hover:text-primary-400 transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-3">热血战斗</h3>
              <p className="text-sm text-foreground-500 mb-4">收录328部正版韩漫</p>
              <span className="inline-flex items-center gap-1 text-sm text-foreground-400 group-hover:text-primary-400 transition-colors duration-200">
                浏览分类 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/category/lianai"
            className="group relative rounded-3xl overflow-hidden bg-background-200/60 hover:bg-background-200 transition-colors duration-300 cursor-pointer"
          >
            <div className="relative aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20genre%20cover%20art%2C%20two%20characters%20intimate%20moment%2C%20soft%20warm%20lighting%2C%20emotional%20webtoon%20illustration%20style%2C%20beautiful%20composition%2C%20dark%20moody%20background%20with%20warm%20glow%2C%20professional%20digital%20art&width=600&height=750&seq=feature-cat-lianai-03&orientation=portrait"
                alt="恋爱甜宠"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="inline-block px-3 py-1.5 text-xs bg-background-50/60 backdrop-blur-sm text-foreground-200 rounded-full">
                  <i className="ri-fire-line mr-1"></i>人气分类
                </span>
              </div>
              <div className="absolute bottom-6 left-6">
                <h3 className="text-xl md:text-2xl font-bold text-foreground-50">恋爱甜宠</h3>
                <p className="text-sm text-foreground-400 mt-2">456部作品</p>
              </div>
            </div>
          </Link>

          <Link
            to="/category/xuanyi"
            className="group relative rounded-3xl overflow-hidden bg-background-200/60 hover:bg-background-200 transition-colors duration-300 cursor-pointer"
          >
            <div className="p-8 md:p-10">
              <div className="w-14 h-14 rounded-2xl bg-background-300/50 flex items-center justify-center mb-6 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className="ri-search-eye-line text-2xl text-foreground-300 group-hover:text-primary-400 transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-3">悬疑惊悚</h3>
              <p className="text-sm text-foreground-500 mb-4">收录187部正版韩漫</p>
              <span className="inline-flex items-center gap-1 text-sm text-foreground-400 group-hover:text-primary-400 transition-colors duration-200">
                浏览分类 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mt-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-200/40 hover:bg-background-200 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-background-300/50 flex items-center justify-center group-hover:bg-primary-500/15 transition-colors duration-200">
                <i className={`${cat.icon} text-xl text-foreground-400 group-hover:text-primary-400 transition-colors duration-200`}></i>
              </div>
              <span className="text-xs text-foreground-400 group-hover:text-foreground-200 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}